"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVideoScreenShot = void 0;

var _react = require("react");

var _VideoController = require("./controllers/VideoController");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useVideoScreenShot = function useVideoScreenShot(containerRef) {
  var vc = _VideoController.VideoController.getInstance(containerRef.current);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      times = _useState2[0],
      setTimes = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      images = _useState4[0],
      setImages = _useState4[1]; // doScreenShot is a method to take a screen shot image of the supplied video element


  var doScreenShot = function doScreenShot(video) {
    if (video) {
      var canvas = document.createElement("canvas");
      canvas.width = video.videoWidth / 3;
      canvas.height = video.videoHeight / 3;
      var ctx = canvas.getContext("2d");
      ctx.imageSmoothingEnabled = false;
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      return canvas.toDataURL("image/png");
    }

    return null;
  };

  (0, _react.useEffect)(function () {
    var onInfo = function onInfo(e) {
      if (e.detail.video_id === "video-player-".concat(containerRef.current)) {
        // eslint-disable-next-line eqeqeq
        var takeAt = times && times.length ? times[0] : null;

        if (takeAt !== null) {
          var diff = Math.abs(e.detail.currentTime - takeAt);

          if (diff < 0.25 && e.detail.readyState >= 3) {
            var imageUrl = doScreenShot(vc.controllingSource.video); // Add our new image url

            var updatedImages = _toConsumableArray(images);

            updatedImages.push(imageUrl);
            setImages(updatedImages); // Adjust our times array (remove the first element)

            var updatedTimes = _toConsumableArray(times);

            if (updatedTimes.length >= 1) {
              updatedTimes.shift();
              vc.jump(updatedTimes[0]);
            }

            setTimes(updatedTimes);
          }
        } else {
          document.removeEventListener("trc-video-info", onInfo);
        }
      }
    };

    document.addEventListener("trc-video-info", onInfo);
    return function () {
      document.removeEventListener("trc-video-info", onInfo);
    };
  }, [times]);

  var takeScreenShot = function takeScreenShot(someTimes) {
    setTimes(someTimes); //  vc.freeze = true
    //  vc.startAt = times[0]

    vc.pause();
    vc.jump(someTimes[0]);
  };

  return {
    takeScreenShot: takeScreenShot,
    screenshots: images
  };
};

exports.useVideoScreenShot = useVideoScreenShot;